;(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? factory(exports)
    : typeof define === 'function' && define.amd
    ? define(['exports'], factory)
    : factory((global.stat = {}))
})(this, function(exports) {
  'use strict'

  function getPlatform_old(ua = navigator.userAgent) {
    var isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isWechat = /(?:MicroMessenger)/.test(ua),
      isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (/Macintosh/i.test(ua) && /Mobile/i.test(ua)) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)),
      isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isiPad =
        (/(?:iPad)/.test(ua) && isTablet) ||
        (/Macintosh/i.test(ua) && /Mobile/i.test(ua)),
      isPc = !isiPhone && !isAndroid && !isSymbian && !isiPad,
      isMobile = !isPc,
      isYixinliApp = /(?:yixinliApp)/.test(ua),
      isMuseApp = /(?:muse)/.test(ua),
      isCeShiApp = /(?:XinLiCeShiApp)/.test(ua),
      isZiXunApp = /(?:yixinliConsultationApp)/.test(ua),
      isQingSuApp = /(?:yixinliPourOutApp)/.test(ua),
      yixinliAPPVersion = isYixinliApp
        ? ua.match(/YIXINLIAPP;*.*.*/i)[0].split(';')[1]
        : null,
      museAPPVersion = isMuseApp
        ? ua.match(/muse;*.*.*/i)[0].split(';')[1]
        : null,
      isBaiduminiapp = /(?:swan-baiduboxapp)/.test(ua),
      isWxmp = /miniProgram/i.test(ua)
    return {
      isWechat,
      isTablet,
      isiPhone,
      isiPad,
      isAndroid,
      isPc,
      isMobile,
      isYixinliApp,
      isMuseApp,
      isCeShiApp,
      isZiXunApp,
      isQingSuApp,
      yixinliAPPVersion,
      museAPPVersion,
      isChrome,
      isBaiduminiapp,
      isWxmp
    }
  }

  function getPlatform() {
    /*
     * 壹心理App 6.7.7 开始，在webview 内置名为 YXL_INFO的对象，包含以下字段
     * app	string	 	App 名称；比如：壹心理
     * version	string	 	App 版本；比如：6.7.7
     * fullscreen	int	 0｜1	是否全面屏；比如：0
     * system	string	 	系统信息；比如：iOS 13.4.1
     * model	string	 	型号；比如：iPhone
     * */
    // EASY_ENV_IS_NODE 是Node项目的全局变量，用于判断是否在Node server上面运行
    var ua =
      arguments.length > 0 && arguments[0] !== undefined
        ? arguments[0]
        : navigator.userAgent
    var isServer = typeof window === 'undefined'
    let PickYxlInfoString = function(pickdata, filter) {
      // 从YXL_INFO获取字段，并且利用filter的方式，将字符串去转换成想要的格式，方便下一步调用
      if (
        !isServer &&
        window &&
        window.YXL_INFO &&
        typeof pickdata == 'string'
      ) {
        // alert(window.YXL_INFO[pickdata])
        let data = window.YXL_INFO[pickdata]
        // iOS拿到的是字符串，安卓返回的是function，所以需要再执行一下
        if (typeof data === 'function') {
          data = window.YXL_INFO[pickdata]() // 只能直接调用，不能引用data()，安卓方面有安全方面的限制
        }
        if (filter && typeof filter == 'function') {
          return filter(data)
        }
        return data
      } else {
        return undefined
      }
    }
    let fullTypeJudge = function(
      Rex,
      targerStringLikeUA,
      { type, isTargetApp, useWierdWay = true } = { useWierdWay: true }
    ) {
      if (isServer) {
        useWierdWay = false
      }
      let regExp = Rex
      let uaMatch = runRex(regExp, targerStringLikeUA)
      // 有window.YXL_INFO，优先级最高，取出app的name，模仿UA判断
      let YxlInfoFilterMap = {
        app: app => {
          let appRegExName
          switch (app) {
            case '壹心理':
              appRegExName = 'yixinliApp'
              break
            case '鲸鱼倾诉':
              appRegExName = 'yixinliPourOutApp'
              break
            case '此刻心理':
              appRegExName = 'cikeApp'
              break
            default:
              appRegExName = 'n0th1ng MaTch'
              break
          }
          return appRegExName
        },
        system: system => {
          /* 会出现几种情况
           * 1. iOS **.*
           * 2. iPadOS **.*（iPad 从 iPadOS 13 起 YXL_INFO.system 为 iPadOS，不再是 iOS）
           * 3. 纯数字版本 安卓返回
           * 4. Android **.* 安卓返回
           * 注意：iPadOS 字符串不包含连续子串 "iOS"（iPad + OS），旧正则会误判为 Android
           */
          let isiOS = /iOS|ios|iPadOS|ipados/i.test(system)
          return isiOS ? 'iOS' : 'Android'
        },
        model: null,
        version: version => {
          // 由于会存在多个App，所以需要确定是不是targetApp才返回version
          if (isTargetApp) {
            return version
          } else {
            return '0.0.0'
          }
        },
        fullscreen: tof => !!tof
      }

      // 其他判断方法
      let clientNavagitorTry = {
        app: () => {
          if (!isServer) {
            let { _platform: searchPlatform } =
              require('./url').getUrlParams({
                url: location.href,
                params: ['_platform']
              }) || ''
            let { _platform: hashPlatform } =
              require('./url').getUrlParams({
                url: location.href,
                type: 'hash',
                params: ['_platform']
              }) || ''
            if (searchPlatform || hashPlatform) {
              return true
            } else {
              return false
            }
          }
        },
        version: () => {
          if (!isServer && isTargetApp) {
            let { _version: searchVersion } =
              require('./url').getUrlParams({
                url: location.href,
                params: ['_version']
              }) || ''
            let { _version: hashVersion } =
              require('./url').getUrlParams({
                url: location.href,
                type: 'hash',
                params: ['_version']
              }) || ''

            if (searchVersion) {
              return searchVersion
            } else if (hashVersion) {
              return hashVersion
            } else {
              return false
            }
          }
        }
      }
      let InfoString = PickYxlInfoString(type, YxlInfoFilterMap[type])

      let wierdWaysToComfirm = type => {
        let canTry = clientNavagitorTry[type]
        if (canTry && useWierdWay) {
          let wierdTryResult = canTry(Rex, targerStringLikeUA)
          console.log('wierdTryResult', wierdTryResult)
          return wierdTryResult
        } else {
          return false
        }
      }

      let wierdWays = wierdWaysToComfirm(type)

      try {
        if (InfoString) {
          // console.log('result1',  InfoString, regExp.toString(), runRex(regExp, InfoString))

          if (type == 'version') {
            console.log(
              '------------------InfoString',
              regExp.toString(),
              InfoString
            )

            return InfoString + ''
          } else {
            console.log(
              '------------------InfoString',
              regExp.toString(),
              runRex(regExp, InfoString)
            )

            return runRex(regExp, InfoString)
          }
        } else if (uaMatch) {
          console.log('------------------', Rex.toString(), uaMatch, wierdWays)
          // console.log('result2',  Rex.toString(), uaMatch, wierdWays)
          // version 需要输出 x.y.z 的数字字符串
          if (type == 'version') {
            if (uaMatch)
              return targerStringLikeUA.match(regExp)[0].split(';')[1]
          } else {
            return uaMatch
          }
        } else if (wierdWays) {
          // 实在没办法，只能相信这个判断
          return wierdWays
        } else {
          return false
        }
      } catch (e) {
        console.error(
          'Error@getPlaftorm:' +
            e.toString() +
            '\nParams' +
            `Rex:${Rex.toString()}, targerStringLikeUA: ${targerStringLikeUA}, type: ${type}, isTargetApp: ${isTargetApp}, useWierdWay: ${useWierdWay}`
        )
      }
    }

    let runRex = function(Rex, targetString) {
      if (Rex.test) {
        return Rex.test(targetString)
      } else {
        return false
      }
    }

    let iPadOS13Up = isServer
      ? false
      : navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 //
    // system / 浏览器（微信/Chrome/Firefox） / 设备 / 自家App
    var isWindowsPhone = fullTypeJudge(/(?:Windows Phone)/, ua),
      isSymbian = fullTypeJudge(/(?:SymbianOS)/, ua) || isWindowsPhone,
      isAndroid = fullTypeJudge(/(?:Android)/, ua, { type: 'system' }),
      isiOS = fullTypeJudge(/(?:iOS)/, ua, { type: 'system' }),
      isHarmonyOS = fullTypeJudge(/OpenHarmony/, ua, { type: 'system' }), // 纯鸿蒙设备
      isFireFox = fullTypeJudge(/(?:FireFox)/, ua),
      isChrome = fullTypeJudge(/(?:Chrome|CriOS)/, ua),
      isWechat = fullTypeJudge(/(?:MicroMessenger)/, ua),
      isiPad = fullTypeJudge(/(?:iPad)/, ua, { type: 'model' }) || iPadOS13Up,
      isiPhone = fullTypeJudge(/(?:iPhone)/, ua, { type: 'model' }), // /(?:iPhone)/.test(ua) && !isTablet,
      isTablet =
        fullTypeJudge(/(?:Tablet|PlayBook)/, ua) ||
        isiPad ||
        (isAndroid && !fullTypeJudge(/(?:Mobile)/, ua)) ||
        (isFireFox && fullTypeJudge(/(?:Tablet)/, ua)),
      isPc = !isiPhone && !isAndroid && !isSymbian && !isiPad && !isHarmonyOS,
      isMobile = !isPc,
      isZiXunApp = fullTypeJudge(/(?:yixinliConsultationApp)/, ua, {
        type: 'app',
        useWierdWay: false
      }), //  /(?:yixinliConsultationApp)/.test(ua),
      isQingSuApp = fullTypeJudge(/(?:yixinliPourOutApp)/, ua, {
        type: 'app',
        useWierdWay: false
      }),
      isYixinliApp = fullTypeJudge(/(?:yixinliApp)/, ua, {
        type: 'app',
        useWierdWay: false
      }),
      isMuseApp = fullTypeJudge(/(?:muse)/, ua, {
        type: 'app',
        useWierdWay: false
      }), //  /(?:muse)/.test(ua),
      isCeShiApp = fullTypeJudge(/(?:XinLiCeShiApp)/, ua, {
        type: 'app',
        useWierdWay: false
      }), //  /(?:XinLiCeShiApp)/.test(ua),
      yixinliAPPVersion = fullTypeJudge(
        /^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/,
        ua,
        {
          type: 'version',
          isTargetApp: isYixinliApp,
          useWierdWay: false // 在非iPad环境都是安全的,不需要用URL判断
        }
      ),
      museAPPVersion = fullTypeJudge(/muse;*.*.*/i, ua, {
        type: 'version',
        isTargetApp: isMuseApp,
        useWierdWay: false
      }), //  isMuseApp
      zixunAppVersion = fullTypeJudge(/yixinliConsultationApp;*.*.*/i, ua, {
        type: 'version',
        isTargetApp: isZiXunApp,
        useWierdWay: false
      }),
      qingsuAppVersion = fullTypeJudge(/yixinliPourOutApp;*.*.*/i, ua, {
        type: 'version',
        isTargetApp: isQingSuApp,
        useWierdWay: false
      }),
      isBaiduminiapp = fullTypeJudge(/(?:swan-baiduboxapp)/, ua), //  /(?:swan-baiduboxapp)/.test(ua)
      isZiXunShiApp = fullTypeJudge(/(?:(Android|iOS)-Counselor)/, ua),
      isWxmp = fullTypeJudge(/miniProgram/, ua),
      isHonorHealth = fullTypeJudge(/HONOR Health/, ua),
      isCikeApp = fullTypeJudge(/(?:cikeApp)/, ua, {
        type: 'app',
        useWierdWay: false
      })
    // console.log('YXL', isYixinliApp, 'YXLZX', isZiXunApp)
    let result = {
      // *system 系统类
      isAndroid: isAndroid,
      isiOS,
      isHarmonyOS,
      // 设备类
      isPc: isPc,
      isMobile: isMobile,
      isTablet: isTablet,

      // *model
      isiPhone: isiPhone,
      isiPad: isiPad,

      // 浏览器类
      isChrome: isChrome,
      isWechat: isWechat,

      // *app 类
      isYixinliApp: isYixinliApp,
      isMuseApp: isMuseApp,
      isCeShiApp: isCeShiApp,
      isZiXunApp: isZiXunApp,
      isQingSuApp: isQingSuApp,
      isZiXunShiApp: isZiXunShiApp,
      isCikeApp: isCikeApp,
      isWxmp: isWxmp,
      isBaiduminiapp: isBaiduminiapp,
      isYxlApp:
        isYixinliApp ||
        isCeShiApp ||
        isZiXunApp ||
        isQingSuApp ||
        isZiXunShiApp ||
        isCikeApp, // 壹心理的APP（多个 APP 都适用的场景）

      // *version 类
      yixinliAPPVersion: yixinliAPPVersion,
      museAPPVersion: museAPPVersion,
      zixunAppVersion: zixunAppVersion,
      qingsuAppVersion: qingsuAppVersion,

      isHonorHealth
    }
    // console.log(result)
    return result
  }

  /*
   * 获取当前环境和是否开发状态/环境
   * box/qc环境/本地运行 都被认为是dev状态
   * env 表示当前环境的 boxX/qcX/'' 字符串
   * */
  function getRunningEnv() {
    var WEBPACK_DEV = WEBPACK_DEV || false
    var result = {}
    var env = location.host.split('.')[0].match(/(qc|box)[0-9]+/g)
    if (!!env || WEBPACK_DEV) {
      result.isDev = 1
      result.env = env.length > 0 ? env[0] : ''
    } else {
      result.isDev = 0
      result.env = ''
    }
    return result
  }

  /*
   * 将 str 转换为适配当前环境的域名
   * */
  function getEnvHost(str) {
    var _getRunningEnv = getRunningEnv(),
      env = _getRunningEnv.env

    var result = str
    if (env) {
      result = str.replace(/\./, '-' + env + '.')
    }
    // console.log(result)
    return result
  }

  function isIOS9() {
    //获取固件版本
    var getOsv = function getOsv() {
      var reg = /OS ((\d+_?){2,3})\s/
      if (
        navigator.userAgent.match(/iPad/i) ||
        navigator.platform.match(/iPad/i) ||
        navigator.userAgent.match(/iP(hone|od)/i) ||
        navigator.platform.match(/iP(hone|od)/i)
      ) {
        var _osv = reg.exec(navigator.userAgent)
        if (_osv.length > 0) {
          return _osv[0]
            .replace('OS', '')
            .replace('os', '')
            .replace(/\s+/g, '')
            .replace(/_/g, '.')
        }
      }
      return ''
    }
    var osv = getOsv()
    var osvArr = osv.split('.')
    // console.log('osv', osv, 'osvArr', osvArr)
    if (osvArr && osvArr.length > 0) {
      if (parseInt(osvArr[0]) <= 9) {
        return true
      }
    }
    return false
  }

  var urlRule = /(node\-website|yiapi|cpapi|m|static|ce|hd|www|medi|meditation){1}(\-(qc\d{1}|box\d{1}))?.(xinli001|onexinli).(com|cc)/ // eslint-disable-line

  var sigleTonPlatform = function(getP) {
    let result
    return function() {
      if (!result) {
        console.log('没有单例')
        result = getP()
      }
      return result
    }
  }

  var getPlatform$1 = {
    urlRule: urlRule,
    getPlatform_old: getPlatform_old,
    getPlatform: getPlatform,
    getRunningEnv: getRunningEnv,
    getEnvHost: getEnvHost,
    isIOS9: isIOS9
  }

  exports.urlRule = urlRule
  exports.getPlatform_old = getPlatform_old
  exports.getPlatform = getPlatform
  exports.getRunningEnv = getRunningEnv
  exports.getEnvHost = getEnvHost
  exports.isIOS9 = isIOS9
  exports.default = getPlatform$1

  Object.defineProperty(exports, '__esModule', { value: true })
})



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/getPlatform.js